import { render, staticRenderFns } from "./seniorLiving.vue?vue&type=template&id=75d5a2b4&scoped=true"
import script from "./seniorLiving.vue?vue&type=script&lang=js"
export * from "./seniorLiving.vue?vue&type=script&lang=js"
import style0 from "./seniorLiving.vue?vue&type=style&index=0&id=75d5a2b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d5a2b4",
  null
  
)

export default component.exports